import { useState, useEffect } from "react";
import axios from "axios";
import "./Dashboard.css";
import "./CreateStory.css";
import Sidebar from "../components/Layout/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { fetchUser, updateUserPassword } from "../redux/authSlice";
import { updateProfile,uploadUserProfileImage  } from "../redux/profileFilterSlice";
import { deleteProfile } from "../redux/profileFilterSlice";
import { fetchMatches } from "../redux/matchFilterSlice";
import StoryForm from "./StoryForm";
import { saveSuccessStory, removeSuccessStoryById, updateSuccessStorySlice, fetchAllSuccessStories } from "../redux/successStorySlice";
import userAvatar from "../img/user-avatar.png";
import Loader from "./Loader";

// const API = "http://localhost:5000/api/user";

const defaultForm = {
  name: "",
  age: "",
  religion: "",
  caste: "",
  location: {
    country: "",
    state: "",
    city: ""
  },
  profession: "",
  salary: "",
  image: "",
  education: "",
  height: "",
  motherTongue: "",
  maritalStatus: "",
  gender: "",
  diet: "",
  smoking: "",
  drinking: "",
  about: "",
  prefAgeMin: "",
  prefAgeMax: "",
  prefHeight:"",
  prefReligion: "",
  prefCaste: "",
  prefLocation: "",
  prefEducation: "",
  prefProfession: "",
  prefSalaryMin: "",
};

const heights = [
  "4'10\"","5'0\"","5'2\"","5'4\"","5'6\"","5'8\"","5'10\"","6'0\"","6'2\"","6'4\"","6'6\"","6'8\"","6'10\"","7'0\""
];

const incomeRanges = ["3–6L", "6–12L", "12–25L", "25L+"];

const TABS = ["Overview", "Personal", "Professional", "Lifestyle", "Preferences", "Gallery"];

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
});

const initials = (name) =>
  name ? name.split(" ").map((n) => n[0]).join("").toUpperCase().slice(0, 2) : "?";

export default function CreateStory({ user, onLogout }) {
  const dispatch = useDispatch();

  // ── Redux state ──────────────────────────────────────────────────────────────
  // fetchUser should resolve to { user, profile } or similar shape.
  // Adjust the selector path to match your actual authSlice state shape.
  const userFromStore = useSelector((state) => state.auth.user);
  console.log('userFromStore:',userFromStore);
  
  const profileFromStore = useSelector((state) => state.auth.profile); // add this to your slice if needed
console.log('profileFromStore:',profileFromStore);

  // ── Local state ──────────────────────────────────────────────────────────────
  const [profile, setProfile] = useState(null);   
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(defaultForm);
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const [activeTab, setActiveTab] = useState("Overview");
  const [shortlisted, setShortlisted] = useState([]);
  const [activeFormTab, setActiveFormTab] = useState("basic");
  const [profileImage, setProfileImage] = useState(null);
  const [allFilterTypes, setAllFilterTypes] = useState([]);
  const [education, setEducation] = useState([]);
  const [profession, setProfession] = useState([]);
  const [userType, setUserType] = useState("");
  const [stories, setStories] = useState([]);
  const [editStory, setEditStory] = useState(null);
  const { list, error } = useSelector((state) => state.matches);
  const userFromLoginResponse = useSelector((state) => state.auth.loginResponse);
  const allSuccessStories = useSelector((state) => state.successStories.stories);

  // Fetch stories (replace with API)
  useEffect(() => {
    // dummy data
    // setStories([
    //   {
    //     id: 1,
    //     coupleName: "Rahul & Priya",
    //     description: "Happy married life",
    //     image: "",
    //   },
    // ]);
    setLoading(true);
    dispatch(fetchAllSuccessStories()).finally(() => setLoading(false));
  }, []);
   
  const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 6;
console.log("Stories:", stories.length);
const totalPages = Math.max(1, Math.ceil(stories.length / itemsPerPage));

const startIndex = (currentPage - 1) * itemsPerPage;
const currentStories = stories.slice(startIndex, startIndex + itemsPerPage);

const goToPage = (page) => {
  if (page < 1 || page > totalPages) return;
  setCurrentPage(page);
};

const getPageNumbers = () => {
  const pages = [];
  const maxVisiblePages = 5;

  let startPage = Math.max(currentPage - 2, 1);
  let endPage = startPage + maxVisiblePages - 1;

  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(endPage - maxVisiblePages + 1, 1);
  }

  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  return pages;
};

  // ── Derived display values ───────────────────────────────────────────────────
  const displayName =
    user?.username || user?.name ||
    userFromStore?.username || userFromStore?.name || "User";

  const displayEmail = user?.email || userFromStore?.email || "";

  const memberSince = (user?.createdAt || userFromStore?.createdAt)
    ? new Date(user?.createdAt || userFromStore?.createdAt).toLocaleDateString("en-IN", {
        month: "short",
        year: "numeric",
      })
    : "Member";

  // ── Fetch profile from API ───────────────────────────────────────────────────
  // This fetches the Profile document (not the User auth doc).
  // Your backend should have GET /api/profiles/me or similar.
  // const fetchProfile = useCallback(async () => {
  //   try {
  //     console.log('handleImageUpload',profile);
      
  //     // Option A: fetch the logged-in user's profile from a dedicated endpoint
  //     const res = await axios.get(`${API}/${userFromStore._id}`, authHeaders());
  //     // res.data should be the Profile document
  //     setProfile(res.data?.profile || res.data || null);
  //   } catch (err) {
  //     // If no profile exists yet (404), that's fine — show empty state
  //     if (err?.response?.status !== 404) {
  //       showToast("Failed to load profile", "error");
  //     }
  //     setProfile(null);
  //   }
  // }, []);

  useEffect(() => {
    if (userFromLoginResponse) {
      setUserType(userFromLoginResponse);
    }
  }, [userFromLoginResponse]);

    useEffect(() => {
      dispatch(fetchMatches());
    }, [dispatch]);

    useEffect(() => {
      if (list?.data) {
        const types = list.data;
        setAllFilterTypes(types);
    
        const religions = types
          .filter(f => f.masterType === "Religion")
          .map(r => r);
    
        // setReligion(religions);
        // console.log('religion:', religion);
    
        // const castes = types
        //   .filter(f => f.masterType === "Caste" && f.parentId?._id !== null)
        //   .map(c => c);
        // setCaste(castes);
        // console.log('caste:', castes);
    
        // get occupation list
        const professions = types.filter(f => f.masterType === "Occupation")
          .map(p => p);
        setProfession(professions);
        console.log('profession:', professions);
    
        //get state list
        // const states = types.filter(f => f.masterType === "State")
        //   .map(s => s);
        // setStates(states);
        // console.log('states:', states);
    
        //get education list
        const education = types.filter(f => f.masterType === "Education")
          .map(e => e);
        setEducation(education);
        console.log('education:', education);
    
      }
      
    }, [list]);



  useEffect(() => {
  if (userFromStore?.profile) {
    setProfile(userFromStore.profile);
    console.log("profile:", userFromStore.profile);
  }
}, [userFromStore]);

useEffect(() => {
  if (profile?.photos?.length) {
    const primary = profile.photos.find((p) => p.isPrimary);
    setProfileImage(primary?.url || profile.photos[0]?.url);
  }
}, [profile]);

  // Pre-fill form name from logged-in user when opening "add" mode
  useEffect(() => {
    if (!editId) {
      setForm((prev) => ({ ...prev, name: displayName }));
    }
  }, [displayName, editId]);

  // ── Toast helper ─────────────────────────────────────────────────────────────
  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };

  // ── Form handlers ────────────────────────────────────────────────────────────
  const handleChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async () => {
    if (!form.fullName || !form.age) return showToast("Name & Age are required", "error");
    setLoading(true);
    try {
      if (editId) {
        // Update existing profile
        // await axios.post(`${API}/`, form, authHeaders());
        await dispatch(updateProfile({ ...form, id: editId })).unwrap();
        await dispatch(fetchUser()).unwrap(); // refresh user/profile in Redux
        showToast("Profile updated!");
      } else {
        // Create new profile
        // await axios.post(API, form, authHeaders());
        await dispatch(updateProfile({ ...form })).unwrap();
        await dispatch(fetchUser()).unwrap(); // refresh user/profile in Redux

        showToast("Profile saved!");
      }
      setEditId(null);
      setShowForm(false);
      // await fetchProfile(); // refresh the displayed profile

    } catch (err) {
      showToast(err?.response?.data?.message || "Error saving profile", "error");
    }
    setLoading(false);
  };

//   const handleEdit = (p) => {
//     setForm({
//       fullName: p.fullName || "",
//       age: p.age || "",
//       religion: p.religion || "",
//       caste: p.caste || "",
// location: {
//   country: p.location?.country || "",
//   state: p.location?.state || "",
//   city: p.location?.city || "",
// },     
//  profession: p.profession || "",
//       salary: p.salary || "",
//       image: p.image || "",
//       education: p.education || "",
//       height: p.height || "",
//       motherTongue: p.motherTongue || "",
//       maritalStatus: p.maritalStatus || "",
//       gender: p.gender || "",
//       diet: p.diet || "",
//       smoking: p.smoking || "",
//       drinking: p.drinking || "",
//       about: p.about || "",
//       // In handleEdit(p), replace the pref fields:
// prefAgeMin: p.partnerPreferences?.ageFrom || p.prefAgeMin || "",
// prefAgeMax: p.partnerPreferences?.ageTo || p.prefAgeMax || "",
// prefHeight: p.partnerPreferences?.height || "",
// prefReligion: p.partnerPreferences?.religion?.join(", ") || p.prefReligion || "",
// prefCaste: p.partnerPreferences?.caste?.join(", ") || p.prefCaste || "",
// prefLocation: p.partnerPreferences?.city?.join(", ") || p.prefLocation || "",
// prefEducation: p.partnerPreferences?.education?.join(", ") || p.prefEducation || "",
// prefProfession: p.partnerPreferences?.profession || "",
// prefSalaryMin: p.partnerPreferences?.salary || "",
//     });
//     setEditId(p?._id);
//     setShowForm(true);
//     setActiveFormTab("basic");
//   };



  const handleImageUpload = async (e, userId) => {
  const file = e.target.files[0];
  if (!file) return;
  const allowedTypes = ["image/jpeg", "image/png", "image/webp", "image/gif"];
  if (!allowedTypes.includes(file.type)) {
    showToast("Only JPG, PNG, WEBP, or GIF images are allowed", "error");
    e.target.value = "";
    return;
  }
  // Size validation (2MB)
  if (file.size > 2 * 1024 * 1024) {
  const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
  showToast(`Image too large (${fileSizeMB} MB). Maximum allowed size is 2MB`, "error");
  e.target.value = "";
  return;
}
  const formData = new FormData();
  formData.append("image", file);
  try {
    //  In handleImageUpload in Dashboard.jsx
const res = await dispatch(uploadUserProfileImage({ profileId: userId, formData })).unwrap();
if (res.profile) {
  setProfile(res.profile);
  showToast("Photo uploaded successfully!");
}
    
  } catch (err) {
    showToast("Image upload failed", "error");
    console.error(err);
  }
};

  // const toggleShortlist = (id) =>
  //   setShortlisted((prev) =>
  //     prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
  //   );

  // A stable random score per profile load
  const [compatibilityScore] = useState(() => Math.floor(60 + Math.random() * 35));

  // ── Stats derived from profile existence ─────────────────────────────────────
  const stats = {
    total: profile ? 1 : 0,
    matched: profile ? Math.floor(Math.random() * 40 + 10) : 0,
    shortlisted: shortlisted.length,
    viewed: profile ? Math.floor(Math.random() * 20 + 5) : 0,
  };

  

  useEffect(() => {
    console.log('allSuccessStories:', allSuccessStories);
    
    setStories(allSuccessStories);
  }, [allSuccessStories]);

  // Add / Update Story
  const handleSave = async (data) => {
    console.log('Saving story:', data);
    
    if (data._id) {
      // update
      // setStories((prev) =>
      //   prev.map((s) => (s._id === data._id ? data : s))
      // );
      console.log('Updated_story_data:', data);
      
      await dispatch(updateSuccessStorySlice(data)); // dispatch to Redux (and API) as well
    } else {
      
      // create
      // const newStory = { ...data, _id: Date.now() };
      // setStories((prev) => [...prev, newStory]);
      await dispatch(saveSuccessStory(data)); // dispatch to Redux (and API) as well
    }

    await dispatch(fetchAllSuccessStories());

    setShowForm(false);
    setEditStory(null);
  };

  // Delete
  const handleDelete = (id) => {
    setStories(stories.filter((s) => s._id !== id));
    dispatch(removeSuccessStoryById(id)); // dispatch to Redux (and API) as well
    dispatch(fetchAllSuccessStories());
  };

  // Edit
  const handleEdit = (story) => {
    setEditStory(story);
    setShowForm(true);
  };

  // ── Render ───────────────────────────────────────────────────────────────────
  return (
    <>
      <div className="app">
        {loading && <Loader />}
        <Sidebar profileImage={profileImage} profileDetails={profile} />

        <main className="main">
          {/* Header */}
          <div className="main-header">
            <div className="main-header-left">
              <h1 className="page-title">
                Matrimony <span>Create Story</span>
              </h1>
              <p className="page-sub">
                Welcome back, <strong>{displayName}</strong>
              </p>
            </div>
            <div className="main-header-right">
              
            </div>
          </div>

          {/* Profile detail or empty state */}
          <div className="tab-content">
            <div className="profile-detail">
              {/* Top Bar */}
              {!showForm && (
                <div className="story-header">
                  <h3>Success Stories</h3>
                  <button className="add-btn" onClick={() => setShowForm(true)}>
                    + Add Story
                  </button>
                </div>
              )}

              {/* Table */}
              {!showForm && (
                <div className="table-wrapper">
                  <table className="story-table">
                    <thead>
                      <tr>
                        <th>Image</th>
                        <th>Couple Name</th>
                        <th>Description</th>
                        <th>Actions</th>
                      </tr>
                    </thead>

                    <tbody>
                      {/* const imageUrl = photos?.url
  ? `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${photos.url}`
  : userAvatar || "/default-avatar.png"; */}
                      {currentStories.map((story) => (
                        <tr key={story._id}>
                          <td>
                            {story.image && (
                              <img 
                                src={story.image ? `${process.env.REACT_APP_UPLOAD_IMAGE_URL}/${story.image}` : userAvatar} 
                                alt="" 
                                className="story-img" 
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = userAvatar;
                                }}
                              />
                            )}
                          </td>
                          <td>{story.coupleName}</td>
                          <td className="story-description">{story.description}</td>
                          <td>
                          <button
                            className="edit-btn"
                            onClick={() => handleEdit(story)}
                            title="Edit"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="15"
                              height="15"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                            </svg>
                          </button>

                          <button
                            className="delete-btn"
                            onClick={() => handleDelete(story._id)}
                            title="Delete"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="15"
                              height="15"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <polyline points="3 6 5 6 21 6" />
                              <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                              <path d="M10 11v6" />
                              <path d="M14 11v6" />
                              <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                            </svg>
                          </button>
                        </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {/* Form */}
              {showForm && (
                <div className="form-card">
                  <StoryForm
                    onSave={handleSave}
                    editData={editStory}
                    onCancel={() => {
                      setShowForm(false);
                      setEditStory(null);
                    }}
                  />
                </div>
              )}
            </div>
            
          </div>
            
           {stories.length > 0 && (
  <div className="pagination">
    <button
      onClick={() => goToPage(currentPage - 1)}
      disabled={currentPage === 1}
    >
      Prev
    </button>

    {getPageNumbers().map((page) => (
      <button
        key={page}
        className={currentPage === page ? "active" : ""}
        onClick={() => goToPage(page)}
      >
        {page}
      </button>
    ))}

    <button
      onClick={() => goToPage(currentPage + 1)}
      disabled={currentPage === totalPages}
    >
      Next
    </button>
  </div>
)}
        </main>
      </div>
     
    </>
  );
}